import "rc-slider/assets/index.css";
import { Props } from "../types";

const CalculatorDesktop = ({ keyzyBudget, onHowIsPossible }: Props) => {

  return (
    <div className="relative z-40 w-full">
      <div className="w-full">
        <table className="w-full  text-right table-fixed">
          <thead>
            <tr className="text-sm uppercase bold ">
              <th></th>
              <th className="p-3 w-[250px] "></th>
            </tr>
          </thead>

          <tbody>
            <tr className="text-2xl border-b text-bold border-landing-blue border-opacity-10 ">
              <th className="text-center border-r border-landing-blue border-opacity-10">
                <div className=" flex flex-col items-start py-8">
                  <h3 className="text-2xl font-bold ">Your home buying budget</h3>
                  <h4 className="text-base text-landing-orange font-bold ">
                    Rent to own a home in 2-3 years
                  </h4>
                </div>
              </th>
              <th className="px-3 py-6 text-5xl border-landing-blue border-opacity-10 text-landing-cherry">
                {keyzyBudget?.indicativeBudget}
              </th>
            </tr>
            <tr className="text-2xl border-b text-bold border-landing-blue border-opacity-10">
              <th className="text-center border-r border-landing-blue border-opacity-10">
                <div className=" flex flex-col items-start py-8">
                  <h3 className="text-2xl font-bold ">Fixed rent for 2-3 years</h3>
                  <h4 className="text-base text-landing-orange font-bold ">
                    No hikes and get it all back at the end!
                  </h4>
                </div>
              </th>
              <th className="px-3 py-6 text-5xl text-landing-cherry border-landing-blue border-opacity-10">
                {keyzyBudget?.rent}
              </th>
            </tr>
            <tr className="text-2xl text-bold border-landing-blue border-opacity-10">
              <th className="text-center border-r border-landing-blue border-opacity-10">
                <div className="flex flex-col items-start py-8">
                  <h3 className="text-2xl font-bold ">Build up a 10% deposit</h3>
                  <h4 className="text-base text-landing-orange font-bold ">
                    100% rent refunded when you buy
                  </h4>
                  <button
                    onClick={onHowIsPossible}
                    className="text-base text-landing-cherry border-landing-blue border-opacity-10 underline cursor-pointer"
                  >
                    How is this possible?
                  </button>
                </div>
              </th>
              <th className="px-3 py-6 text-5xl text-landing-cherry border-landing-blue border-opacity-10">
                {keyzyBudget?.deposit}
              </th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CalculatorDesktop;
